import React from 'react';
import clsx from 'clsx';

import { Button, Modal, Text } from '@auspost/postmaster-react';

import { ErrorType } from '../hooks/InlineEdd.hooks';
import { INLINE_EDD_CLOSE_BUTTON_TEST_ID, INLINE_EDD_ERROR_MODAL_CONTENT_TEST_ID } from '../InlineEdd.test-ids';

import styles from '../InlineEdd.module.scss';

interface ErrorModalProps {
  errorType: string;
  handleClose: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ errorType, handleClose }) => (
  <>
    <Modal.Header closeButton={false} className={styles.inlineEddModalHeader}>
      <h3 className={styles.inlineEddModalHeading}>Dates can’t be calculated</h3>
    </Modal.Header>
    <Modal.Content>
      <Text
        variant='body'
        className={styles.inlineEddModalContent}
        data-testid={INLINE_EDD_ERROR_MODAL_CONTENT_TEST_ID}
      >
        {errorType === ErrorType.NO_CONTENT
          ? `We can’t calculate expected arrival dates for this parcel, but you’ll still get tracking updates as it progresses.`
          : `It looks like something went wrong on our end. Please try again later.`}
      </Text>
    </Modal.Content>
    <Modal.Footer alignment='right'>
      <Button
        size='medium'
        variant='primary'
        className={clsx(styles.inlineEddModalButton, styles.closeButton)}
        onClick={handleClose}
        data-testid={INLINE_EDD_CLOSE_BUTTON_TEST_ID}
      >
        Close and continue
      </Button>
    </Modal.Footer>
  </>
);

export default ErrorModal;
